export const LOAD_MANAGER_PPQ_QUESTIONNAIRE = "LOAD_MANAGER_PPQ_QUESTIONNAIRE";
